import { css } from '@/styled-system/css';

/**
 * Show nav controls by default but hide them on touch screens.
 * Uses `hover` and `pointer` media queries instead of screen size
 * to ensure nav controls are visible to desktop users who are zoomed in.
 */
export const carouselNavControlsStyles = css.raw({
  'display': 'flex',
  'alignItems': 'start',
  'gap': 'Carousel.Heading.gap.betweenNav',

  '@media (hover: none) and (pointer: coarse)': {
    display: 'none',
  },
});
